import { isEmpty } from 'lodash'

export default {
  prepareSave (speciality) {
    if (isEmpty(speciality.attachment.content)) {
      delete speciality.attachment
    }

    return speciality
  },
  prepareShow (speciality) {
    return speciality
  },
  afterUpdated () {
    this.beenUpdated = true
    this.show = true
  },
  afterCreated () {
    this.wasRaised = true
    this.show = true
  },
  redirectToProfessionalRecordSpecialities () {
    return this.$router.push({name: 'professional.record.specialities.index'})
  },
  newSpeciality () {
    this.speciality.speciality = ''
    this.speciality.rqe = null
    this.$router.push({name: 'professional.record.specialities.create'})
    this.show = false
  },
  newCompany () {
    this.$router.push({name: 'professional.company.addresses.create'})
    this.show = false
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/record/specialities/form/resources/methods.js